{
	"form": {
		"rateExperience": "Arvioi kokemuksesi",
		"buyingFrom": "Ostan:",
		"commentPlaceholder": "Kerro kokemuksestasi… (vapaaehtoinen)",
		"submit": "Lähetä arvostelu",
		"submitting": "Lähetetään…"
	},
	"submitted": {
		"title": "Kiitos arvostelustasi!",
		"feedbackHelps": "Palautteesi auttaa",
		"community": "yhteisöä."
	}
}
